import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaBars, FaTimes, FaFacebook, FaInstagram, FaTwitter, FaWhatsapp, FaPhoneAlt, FaEnvelope, FaLinkedin } from 'react-icons/fa';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [logoError, setLogoError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const navLinks = [
    { name: 'Home', href: '/', id: 1 },
    { name: 'About', href: '/about', id: 2 },
    { name: 'Services', href: '/services', id: 3 },
    { name: 'Contact', href: '/contact', id: 4 },
  ];

  const handleBookService = () => {
    navigate('/book-service');
    setIsOpen(false);
  };

  return (
    <>
      <nav className={`fixed w-full z-50 top-0 left-0 transition-all duration-500 ${
        scrolled ? 'bg-white shadow-lg py-2' : 'bg-white/95 backdrop-blur-md py-3'
      }`}>
        {/* Top Bar - Contact Info - RED BACKGROUND */}
        <div className="hidden lg:block w-full bg-red-600">
          <div className="container mx-auto px-4 md:px-8">
            <div className="flex justify-between items-center py-2">
              <div className="flex items-center gap-6">
                <div className="flex items-center gap-2">
                  <FaPhoneAlt className="text-white text-xs" />
                  <a href="tel:+918081321406" className="text-white text-xs hover:text-gray-200 transition-colors">+91 8081321406</a>
                </div>
                <div className="flex items-center gap-2">
                  <FaEnvelope className="text-white text-xs" />
                  <a href="mailto:info@ambrisservice.com" className="text-white text-xs hover:text-gray-200 transition-colors">info@ambrisservice.com</a>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-white text-xs">Follow us:</span>
                <a href="#" className="text-white hover:text-gray-200 transition-all duration-300 hover:scale-110">
                  <FaFacebook className="text-sm" />
                </a>
                <a href="#" className="text-white hover:text-gray-200 transition-all duration-300 hover:scale-110">
                  <FaInstagram className="text-sm" />
                </a>
                <a href="#" className="text-white hover:text-gray-200 transition-all duration-300 hover:scale-110">
                  <FaTwitter className="text-sm" />
                </a>
                <a href="#" className="text-white hover:text-gray-200 transition-all duration-300 hover:scale-110">
                  <FaLinkedin className="text-sm" />
                </a>
                <a href="#" className="text-white hover:text-gray-200 transition-all duration-300 hover:scale-110">
                  <FaWhatsapp className="text-sm" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Main Navbar */}
        <div className="container mx-auto px-4 md:px-8">
          <div className="flex justify-between items-center">
            
            {/* Logo Section */}
            <Link to="/" className="flex items-center gap-3 group cursor-pointer">
              <div className="relative">
                {!logoError ? (
                  <img
                    src="/logo.png"
                    alt="Ambris Logo"
                    className="w-14 h-12 md:w-12 md:h-12 object-contain"
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-r from-red-500 to-red-700 rounded-xl flex items-center justify-center shadow-md group-hover:shadow-lg transition-all duration-300 group-hover:scale-105">
                    <span className="text-white font-bold text-xl">A</span>
                  </div>
                )}
              </div>
              <div>
                <h1 className="text-gray-800 font-bold text-lg md:text-xl tracking-tight">
                  Ambris<span className="text-red-600">Service</span>
                </h1>
                <p className="text-gray-500 text-[10px] md:text-xs hidden sm:block">Bike & Car Service Center</p>
              </div>
            </Link>

            {/* Desktop Navigation Links */}
            <div className="hidden md:flex items-center gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.id}
                  to={link.href}
                  className="relative text-gray-600 hover:text-red-600 px-4 py-2 text-sm lg:text-base font-medium transition-all duration-300 group"
                  onClick={() => setIsOpen(false)}
                >
                  {link.name}
                  <span className="absolute bottom-0 left-1/2 w-0 h-0.5 bg-gradient-to-r from-red-500 to-red-600 transition-all duration-300 group-hover:w-full group-hover:left-0 rounded-full"></span>
                </Link>
              ))}
            </div>

            {/* Desktop Book Button */}
            <div className="hidden md:flex items-center gap-4">
              <button 
                onClick={handleBookService}
                className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-5 py-2 rounded-full text-sm font-semibold transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg flex items-center gap-2"
              >
                Book Service
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={toggleMenu}
              className="md:hidden text-gray-600 text-2xl focus:outline-none p-2 rounded-lg hover:bg-gray-100 transition-colors"
              aria-label="Toggle menu"
            >
              {isOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>

          {/* Mobile Navigation Menu */}
          <div
            className={`md:hidden fixed left-0 right-0 bg-white shadow-xl transition-all duration-400 ease-in-out overflow-hidden ${
              isOpen ? 'max-h-[550px] opacity-100' : 'max-h-0 opacity-0'
            }`}
            style={{ top: scrolled ? '60px' : '70px' }}
          >
            <div className="flex flex-col px-5 py-5 space-y-3">
              {/* Contact Info Mobile - RED BACKGROUND */}
              <div className="w-full bg-red-600 px-4 py-3 rounded-lg -mx-5" style={{ width: 'calc(100% + 40px)' }}>
                <div className="space-y-2">
                  <div className="flex items-center gap-3">
                    <FaPhoneAlt className="text-white text-sm" />
                    <a href="tel:+918081321406" className="text-white text-sm hover:text-gray-200 transition-colors">+91 8081321406</a>
                  </div>
                  <div className="flex items-center gap-3">
                    <FaEnvelope className="text-white text-sm" />
                    <a href="mailto:info@ambrisservice.com" className="text-white text-sm hover:text-gray-200 transition-colors">info@ambrisservice.com</a>
                  </div>
                </div>
              </div>

              {/* Nav Links Mobile */}
              {navLinks.map((link) => (
                <Link
                  key={link.id}
                  to={link.href}
                  onClick={() => setIsOpen(false)}
                  className="text-gray-600 hover:text-red-600 hover:bg-red-50 px-4 py-3 rounded-xl transition-all duration-200 text-base font-medium"
                >
                  {link.name}
                </Link>
              ))}
              
              {/* Book Service Mobile Link */}
              <button
                onClick={handleBookService}
                className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-5 py-3 rounded-xl text-sm font-semibold transition-all duration-200 mt-2 w-full flex items-center justify-center gap-2"
              >
                Book Service
              </button>
              
              {/* Social Icons Mobile */}
              <div className="flex items-center gap-4 pt-4 pb-2 border-t border-gray-100 mt-2">
                <span className="text-gray-500 text-xs">Follow us:</span>
                <a href="#" className="text-gray-400 hover:text-blue-600 transition-all duration-300 hover:scale-110">
                  <FaFacebook className="text-base" />
                </a>
                <a href="#" className="text-gray-400 hover:text-pink-600 transition-all duration-300 hover:scale-110">
                  <FaInstagram className="text-base" />
                </a>
                <a href="#" className="text-gray-400 hover:text-blue-400 transition-all duration-300 hover:scale-110">
                  <FaTwitter className="text-base" />
                </a>
                <a href="#" className="text-gray-400 hover:text-blue-700 transition-all duration-300 hover:scale-110">
                  <FaLinkedin className="text-base" />
                </a>
                <a href="#" className="text-gray-400 hover:text-green-600 transition-all duration-300 hover:scale-110">
                  <FaWhatsapp className="text-base" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Spacer to prevent content from hiding under navbar */}
      <div className="h-16 md:h-24"></div>

      <style jsx>{`
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </>
  );
};

export default Navbar;